/**
 * Retorna o nome do status baseado no código
 * @param {string} statusCode - Código do status ('1', '2', '3', '4', etc.)
 * @returns {string} - Nome do status
 */
export default function getStatusName(statusCode) {
  switch (statusCode) {
    case '1':
      return 'Iniciado';
    case '2':
      return 'Em atendimento';
    case '3':
      return 'Cancelado';
    case '4':
      return 'Finalizado';
    default:
      return 'Enviado';
  }
}
